import { render, staticRenderFns } from "./FeaturedCategoriesWidgetCard.vue?vue&type=template&id=1fcaca0c&scoped=true"
import script from "./FeaturedCategoriesWidgetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedCategoriesWidgetCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FeaturedCategoriesWidgetCard.vue?vue&type=style&index=0&id=1fcaca0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcaca0c",
  null
  
)

export default component.exports